import { Component, Inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, ValidationErrors, ValidatorFn, Validators } from "@angular/forms";
import { ActivatedRoute } from "@angular/router";
import { TalentHappyPathDataService } from "../../shared/service/talent-happy-path-data-service";
import { PersonType } from '../../../enums';
import { Environment } from 'src/typings';
import { EnvironmentToken } from 'src/util';
import { TalentHappyPathAuthService } from "../../shared/service/talent-happy-path-auth.service";
import { TalentHappyPathAuthApiService } from "../../shared/service/talent-happy-path-auth-api.service";
import { QuickApplyWorkflowService } from "../quick-apply-workflow.service";

@Component({
  selector: 'app-quick-apply-start',
  standalone: false,
  templateUrl: './quick-apply-start.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './quick-apply-start.component.scss'
})
export class QuickApplyStartComponent implements OnInit {

  emailForm: FormGroup;
  talent: Talent;
  matUrl: string;
  postingId: number;

  constructor(private authAPIService: TalentHappyPathAuthApiService,
              protected talentHappyPathDataService: TalentHappyPathDataService,
              private route: ActivatedRoute,
              @Inject(EnvironmentToken) private environment: Environment,
              private authService: TalentHappyPathAuthService,
              private activatedRoute: ActivatedRoute,
              private workflowService: QuickApplyWorkflowService) {
    this.matUrl = this.environment.matHost;
  }

  async ngOnInit(): Promise<void> {
    this.activatedRoute.queryParams.subscribe(params => {
      if (Object.keys(params).length > 0) {
        let marketingData = <MarketingTrackingInfo>{};
        marketingData.url = params["url"];
        marketingData.utmCampaign = params["utm_campaign"];
        marketingData.utmMedium = params["utm_medium"];
        marketingData.utmSource = params["utm_source"];
        marketingData.utmTerm = params["utm_term"];
        marketingData.utmContent = params["utm_content"];
        marketingData.gclid = params["gclid"];
        this.talentHappyPathDataService.marketingData = marketingData;
      }
    });
    this.talent = <Talent>{}
    this.emailForm = new FormGroup({
      email: new FormControl('', [Validators.required, this.emailUsernameValidator]),
    });
  }

  emailUsernameValidator: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
    if (control.value.includes('@')) {
      return Validators.email(control);
    } else {
      return Validators.pattern(/^[a-zA-Z0-9_. -]*$/)(control);
    }
  }

  async submit(form: FormGroup): Promise<void> {

      // if user is authenticated, load talent data from token
      this.talentHappyPathDataService.talent = null;

    if (this.authService.isAuthenticated() && !this.talentHappyPathDataService.isGeneralApplication) {
        // Redirect authenticated users to the profile page
      this.authAPIService.searchTalentByToken(this.authService.authentication.id_token, String(this.talentHappyPathDataService.postingId))
        .subscribe(async data => {
          this.talent = data;
          this.talentHappyPathDataService.talent = data;
          if (data.email === this.emailForm.value.email) {
            await this.workflowService.navigateToState('submit', {} , { relativeTo: this.route.parent });
          } else {
            await this.workflowService.navigateToState('otp', {}, { skipLocationChange: true, relativeTo: this.route.parent });
          }
      });
      } else {
        this.authAPIService.searchTalent(this.emailForm.value.email, this.talentHappyPathDataService.postingId).subscribe(async data => {
          if (data.personId === null
              || data.personId === undefined
              || (data.personTypeId === PersonType.EMPLOYEE
                  || data.personTypeId === PersonType.PARTNER
                  || data.personTypeId === PersonType.APPLICANT)) {
            if (this.talentHappyPathDataService.isGeneralApplication) {
              data.homeLocation = this.emailForm.get('homeLocation').value;
              data.countryId = this.emailForm.get('countryId').value;
              data.geoLocation = this.emailForm.get('geoLocation').value;
              // Carry the home location's country through with the rest of the picked location: the submit page's
              // picker starts empty for a general application, so this is the only place it is captured unless the
              // Talent picks their location a second time (BIZ-40245).
              data.homeLocationCountryCode = this.emailForm.get('homeLocationCountryCode').value;
            }
            this.talent = data;
            this.talentHappyPathDataService.talent = data;
            await this.workflowService.navigateToState('otp', {}, { skipLocationChange: true, relativeTo: this.route.parent });
          } else {

            // redirect to MyAquent since we did get a personId, so they are known to us, but it is not
            // a talent personType.

            window.location.href = this.matUrl;
          }
        }, error => {
          this.emailForm.controls['email'].setErrors({invalid: true});
        });
      }
  }
}
